import DOMPurify from "dompurify";

/**
 * Returns a props object suitable for `dangerouslySetInnerHTML`.
 * HTML is sanitized with DOMPurify (default config strips scripts,
 * event handlers, javascript: URIs, unsafe tags, etc.).
 *
 * Usage: <div dangerouslySetInnerHTML={htmlSafe(content)} />
 */
export const htmlSafe = (raw) => ({
  __html: DOMPurify.sanitize(raw || "", { USE_PROFILES: { html: true } }),
});
